import { createApiClient } from "#/shared/api/client";

const OPTION_LISTS = Object.freeze(["visitTypes", "departments", "providers"]);

function isPayload(data) {
  return data !== null && typeof data === "object" && OPTION_LISTS.some((list) => Array.isArray(data[list]));
}

/**
 * Creates the Epic widget launcher's server API.
 *
 * @param {String} optionsUrl - The launcher's JSON endpoint.
 */
export const createEpicWidgetLauncherApi = (optionsUrl) => {
  const client = createApiClient({ parse: false });

  /**
   * Requests the options the dialog offers.
   *
   * @param {Object} request
   * @param {String} [request.physicianId] - Id of the Physician the dialog was opened for. Leave it out for a visit type.
   * @returns {Promise<Object>} One `{ title, value }` array per list of `OPTION_LISTS` the dialog asks for.
   * @throws {Error} When the request fails or the response is not a launcher payload.
   */
  async function options({ physicianId } = {}) {
    const query = physicianId ? { physician_id: physicianId } : {};
    const data = await client.get(optionsUrl, query);

    // A redirect can end on an HTML page that still answers 200.
    if (!isPayload(data)) {
      throw new Error("The Epic widget launcher response was not a list of options.");
    }

    return data;
  }

  return { options };
};
